import _holidays from './holidays';

export const zeroPad = (s) => (`00${s}`).slice(-2);

export const formatDate = (date) => {
  const y = date.getFullYear();
  const m = zeroPad(date.getMonth() + 1);
  const d = zeroPad(date.getUTCDate());
  const s = `${y}-${m}-${d}`;
  return s;
};

export const isWorkingDay = (date) => (
  !!(_holidays[formatDate(date)] || date.getDay() === 0 || date.getDay() === 6)
);

export const workingDaysLater = (date, days) => {
  let remaining = days;
  const newDate = new Date(date);
  while (remaining > 0) {
    newDate.setDate(newDate.getDate() + 1);
    if (!isWorkingDay(newDate)) remaining -= 1;
  }
  return newDate;
};

export const holidays = _holidays;
